const AppFooter = () => (
  <footer className="text-body-secondary py-5">
    <div className="container">
      <p className="float-end mb-1">
        <a href="#">Back to top</a>
      </p>
      <p className="mb-1">SQS Lambda Assistant!</p>
      <p className="mb-0">
        New to Bootstrap? <a href="/">Visit the homepage</a> or read our
        <a href="../getting-started/introduction/">getting started guide</a>.
      </p>
    </div>
  </footer>
);
export default AppFooter;
